<template>
	<div>
		<div class="top">
			<a :href="item.url" class="title">
				{{ item.title }}
			</a>
			<div class="salary">
				{{ item.salary }}<span>{{ item.danwei }}</span>
			</div>
		</div>
		<div class="middle">
			<div class="company">{{ item.qyname }}</div>
			<div class="desc">
				<span>{{ item.degree }}</span> |
				<span>{{ item.xueliyaoqiu }}</span> |
				<span>{{ item.experience }}</span>
			</div>
		</div>
		<div class="bottom">
			<div class="tag">
				<div v-if="item.businesstag">
					{{ item.businesstag }}
				</div>
				<div
					v-for="(tag, index) in item.signsList.slice(0, 3)"
					:key="index"
				>
					{{ tag.tagName }}
				</div>
			</div>
			<div
				class="delivery"
				@click="
					!item.isApply &&
						!isdelivered &&
						delivery(item.infoID, item.tjfrom)
				"
			>
				<div class="words">
					{{ item.isApply || isdelivered ? '已投递' : '投递' }}
				</div>
				<img
					v-if="item.isApply || isdelivered"
					src="../../assets/delivered.png"
					alt=""
				/>
				<img v-else src="../../assets/delivery.png" alt="" />
			</div>
		</div>
	</div>
</template>

<script>
import { ref } from '@vue/composition-api';
export default {
	name: 'List',
	props: {
		item: {
			type: Object
		}
	},
	emits: ['getData'],
	setup() {
		const isdelivered = ref(false);
		const delivery = (infoID, tjfrom) => {
			const params = {
				infoId: infoID,
				tjFrom: tjfrom,
				deliverySource: '150',
				finalCp: '',
				areaid: '',
				role: '',
				psid: '',
				displayGuideBox: true,
				deliveryCallBackFn: function () {
					isdelivered.value = true;
				}
			};
			window.delivery_new(params);
		};
		return {
			delivery,
			isdelivered
		};
	}
};
</script>

<style lang="scss">
.top {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	.title {
		font-family: PingFangSC-Medium;
		font-size: 24px;
		font-weight: 500;
		color: rgba(10, 13, 87, 1);
		text-align: left;
	}
	.title:hover {
		cursor: pointer;
	}
	.salary {
		font-family: PingFangSC-Medium;
		font-size: 24px;
		font-weight: 500;

		color: rgba(255, 85, 46, 1);
		text-align: left;
		span {
			font-family: PingFangSC-Medium;
			font-size: 21px;
			font-weight: 500;
			color: rgba(255, 85, 46, 1);
			text-align: left;
		}
	}
}
.middle {
	margin-top: 10px;
	font-family: 'PingFangSC-Light', 'Hiragino Sans GB', arial, Tahoma, SimSun,
		宋体, 'sans-serif';
	font-size: 19px;
	font-weight: 300;
	color: rgba(9, 12, 86, 1);
	text-align: left;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	max-width: 70%;
	white-space: nowrap;
	.company {
		max-width: 65%;
		margin-right: 12px;
		white-space: nowrap;
		word-break: break-all;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}
.bottom {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1px;
	.tag {
		div {
			height: 25px;
			display: inline-block;
			box-sizing: border-box;
			text-align: center;
			border-radius: 2px;
			font-family: 'PingFangSC-Light', 'Hiragino Sans GB', arial, Tahoma,
				SimSun, 宋体, 'sans-serif';
			font-size: 16px;
			font-weight: normal;
			color: rgba(255, 255, 255, 1);
			text-align: left;
			padding: 0 7px;
			margin-right: 7px;
			line-height: 25px;
		}
		div:nth-child(1) {
			background: linear-gradient(
				115.1deg,
				rgba(255, 207, 56, 1) 0%,
				rgba(255, 207, 56, 1) 2%,
				rgba(255, 28, 105, 1) 80%,
				rgba(255, 28, 105, 1) 100%
			);
		}
		div:nth-child(2) {
			background: linear-gradient(
				115.1deg,
				rgba(255, 112, 55, 1) 0%,
				rgba(255, 112, 55, 1) 2%,
				rgba(255, 28, 105, 1) 80%,
				rgba(255, 28, 105, 1) 100%
			);
		}
		div:nth-child(3) {
			background: linear-gradient(
				115.8deg,
				rgba(0, 202, 255, 1) 0%,
				rgba(0, 202, 255, 1) 7.000000000000001%,
				rgba(0, 114, 255, 1) 77%,
				rgba(0, 114, 255, 1) 100%
			);
		}
		div:nth-child(4) {
			background: linear-gradient(
				109.2deg,
				rgba(255, 193, 152, 1) 0%,
				rgba(255, 193, 152, 1) 4%,
				rgba(255, 128, 45, 1) 50%,
				rgba(255, 128, 45, 1) 100%
			);
		}
	}
	.delivery {
		width: 120px;
		height: 51px;
		position: relative;
		text-align: center;
		.words {
			width: 80px;
			font-size: 19px;
			font-weight: 500;
			position: absolute;
			color: #fff;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
		.words:hover {
			cursor: pointer;
		}

		img {
			width: 120px;
			height: 51px;
		}
		img:hover {
			cursor: pointer;
		}
	}
}

.division {
	margin-top: 10px;
	text-align: center;
	margin-bottom: 10px;
}
</style>
